import React, { useEffect, useState } from "react";
import "./styles.css";
import {
  Button,
  ButtonGroup,
  FormControlLabel,
  Switch,
  TextField,
} from "@material-ui/core";
import MonthBundle from "./month-bundle";
import AddNewMonthForm from "./add-new-month";

const SubscriptionCard = (props: any) => {
  const [isAddNewMonth, setIsAddNewMonth] = useState(false);
  const [isEdit, setEdit] = useState(false);
  const [isEditMonths, setEditMonths] = useState(false);
  const [isLoading, setLoading] = useState(false);
  const [subscriptionModel, setSubscriptionModel] = useState(props.data);
  const [months, setMonths] = useState(props.data.months ?? []);
  function roundedPrice(price: number): number {
    if (!price) {
      return 0;
    }
    return Math.round((price + Number.EPSILON) * 100) / 100;
  }

  function priceFormat(value: any) {
    if (!value) {
      return `£0`;
    }
    if (value % 1 === 0) {
      return `£${value}`;
    }
    if (value < 1) {
      const res: number = roundedPrice(value) * 100;
      return `${parseInt(res.toString())}p`;
    } else {
      return `£${roundedPrice(value).toFixed(2)}`;
    }
  }
  const getTotalPrice = () => {
    return priceFormat(subscriptionModel.totalCost / 100);
  };
  const totalCost = getTotalPrice();
  const handleSubmit = async () => {
    setLoading(true);
    const res = await props.updateSubscription(props.data._id, {
      update: {
        totalCost: subscriptionModel.totalCost,
        numOfTickets: subscriptionModel.numOfTickets,
        extra: subscriptionModel.extra,
        isActive: subscriptionModel.isActive,
        isBonusActive: subscriptionModel.isBonusActive ?? false,
        bonusPeriod: subscriptionModel.bonusPeriod ?? 2,
        bonusTickets: subscriptionModel.bonusTickets ?? 0,
      },
    });
    console.log(res);

    console.log("updated");
    setEdit(false);
    //   .then((res) => {
    //     console.log('update response: ', res);
    //     setLoading(false);
    //   })
    //   .catch((err) => {
    //     setLoading(false);
    //   });
    setLoading(false);
  };

  const handleChange = (e: any) => {
    setSubscriptionModel({
      ...subscriptionModel,
      [e.target.name]: Number(e.target.value),
    });
  };
  const handleEdit = () => {
    setEdit(true);
  };
  const handleChangeStatus = (e: any) => {
    setSubscriptionModel({ ...subscriptionModel, isActive: e.target.checked });
  };
  const handleChangeBonusStatus = (e: any) => {
    setSubscriptionModel({
      ...subscriptionModel,
      isBonusActive: e.target.checked,
    });
  };

  const handleCancel = () => {
    setEdit(false);
    setSubscriptionModel(props.data);
  };
  const handleAddNewMonth = async (newMonth) => {
    setLoading(true);
    let res = await props.addMonth(props.data._id, {
      month: newMonth,
    });
    setIsAddNewMonth(false);
    setLoading(false);
  };

  useEffect(() => {
    setMonths(props.data.months);
  }, [props.data.months.length]);

  return (
    <div className={`subscription-card ${isEdit ? "edit" : ""}`}>
      <div className="flex-content">
        <div className="main-content">
          <div className="data">
            {isEdit ? (
              <FormControlLabel
                control={
                  <Switch
                    checked={subscriptionModel.isActive}
                    onChange={handleChangeStatus}
                  />
                }
                label={subscriptionModel.isActive ? "Active" : "Disabled"}
              />
            ) : (
              <p className={`status`}>
                {subscriptionModel.isActive ? "Active" : "Disabled"}
              </p>
            )}
            {isEdit ? (
              <TextField
                className="edit-field"
                size="small"
                required
                label="Monthly Cost"
                name="totalCost"
                type="number"
                variant="outlined"
                onChange={handleChange}
                value={subscriptionModel.totalCost}
              />
            ) : (
              <p className="price">
                {totalCost} <span className="tickets-count">/month</span>
              </p>
            )}

            {isEdit ? (
              <>
                <TextField
                  className="edit-field"
                  size="small"
                  required
                  label="Num Of Tickets"
                  name="numOfTickets"
                  type="number"
                  variant="outlined"
                  onChange={handleChange}
                  value={subscriptionModel.numOfTickets}
                />
                <TextField
                  className="edit-field last"
                  size="small"
                  required
                  label="Extra"
                  name="extra"
                  type="number"
                  variant="outlined"
                  onChange={handleChange}
                  value={subscriptionModel.extra}
                />
              </>
            ) : (
              <p className="tickets-count">
                {subscriptionModel.extra + subscriptionModel.numOfTickets}{" "}
                tickets
              </p>
            )}
            <div className="bonus-part">
              {subscriptionModel.isBonusActive !== null ||
              subscriptionModel.isBonusActive !== undefined ? (
                <>
                  <div>
                    {isEdit ? (
                      <FormControlLabel
                        control={
                          <Switch
                            checked={subscriptionModel.isBonusActive}
                            onChange={handleChangeBonusStatus}
                          />
                        }
                        label={
                          subscriptionModel.isBonusActive
                            ? "Bonus Active"
                            : "Bonus Disabled"
                        }
                      />
                    ) : (
                      <p className={`bonus-status`}>
                        {subscriptionModel.isBonusActive
                          ? "Bonus Active"
                          : "Bonus Disabled"}
                      </p>
                    )}
                  </div>
                  <div className="bonus-period">
                    {isEdit ? (
                      <TextField
                        className="edit-field last"
                        size="small"
                        required
                        label="Bonus Period(month)"
                        name="bonusPeriod"
                        type="number"
                        variant="outlined"
                        onChange={handleChange}
                        value={subscriptionModel.bonusPeriod}
                      />
                    ) : (
                      <p className="bonus-tickets-count">
                        each {subscriptionModel.bonusPeriod} month
                      </p>
                    )}
                  </div>
                  <div className="bonus-tickets">
                    {isEdit ? (
                      <TextField
                        className="edit-field last"
                        size="small"
                        required
                        label="Bonus Tickets"
                        name="bonusTickets"
                        type="number"
                        variant="outlined"
                        onChange={handleChange}
                        value={subscriptionModel.bonusTickets}
                      />
                    ) : (
                      <p className="bonus-tickets-count">
                        {subscriptionModel.bonusTickets} tickets
                      </p>
                    )}
                  </div>
                </>
              ) : (
                <>
                  <p>Not Setted up</p>
                </>
              )}
            </div>
          </div>
          <div className="buttons">
            {isEdit ? (
              <ButtonGroup
                variant="contained"
                aria-label="outlined button group"
              >
                <Button
                  size="small"
                  color="primary"
                  onClick={handleSubmit}
                  disabled={isLoading}
                >
                  Save
                </Button>
                <Button
                  size="small"
                  color="primary"
                  onClick={handleCancel}
                  disabled={isLoading}
                >
                  Cancel
                </Button>
              </ButtonGroup>
            ) : (
              <ButtonGroup
                variant="contained"
                aria-label="outlined button group"
                disabled={isLoading}
              >
                <Button size="small" color="primary" onClick={handleEdit}>
                  Edit Subscription
                </Button>
              </ButtonGroup>
            )}
          </div>
        </div>
        <div className="info-content">
          {subscriptionModel.label && subscriptionModel.label.length ? (
            <div className="info-content__label">
              <span>{subscriptionModel.label}</span>
            </div>
          ) : null}
          {subscriptionModel.details && subscriptionModel.details.length ? (
            <ul className="info-content__details">
              {subscriptionModel.details.map((item: string, index: number) => {
                return (
                  <li className="info-content__details-item" key={index}>
                    {item}
                  </li>
                );
              })}
            </ul>
          ) : null}
        </div>
        <div className="months-content">
          <div className="months-part-header">
            <h4>Month List</h4>
          </div>
          <div className="months-part">
            {months.map((month, index) => {
              return (
                <MonthBundle
                  subscriptionModelId={props.data._id}
                  key={index}
                  item={month}
                  index={index}
                  update={props.updateMonth}
                />
              );
            })}
          </div>
          <div className="buttons">
            {isAddNewMonth ? (
              <AddNewMonthForm
                subscriptionModelId={props.data._id}
                item={months[0]}
                update={props.updateMonth}
                onCancel={() => {
                  setIsAddNewMonth(false);
                }}
                onSubmit={handleAddNewMonth}
              />
            ) : (
              <Button
                size="small"
                color="primary"
                // onClick={handleSubmit}
                onClick={async () => {
                  setIsAddNewMonth(true);
                  // setLoading(true);
                  // let res = await props.addMonth(props.data._id, {
                  //   month: {
                  //     month: 20,
                  //     active: false,
                  //     discountActive: false,
                  //     discount: 0,
                  //     discountString: '',
                  //   },
                  // });
                  // setLoading(false);
                }}
                // disabled={isLoading}
              >
                Add new month
              </Button>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default SubscriptionCard;
